import React ,{useState,useEffect,useRef} from 'react'
import Select from "./preview/Select";
import Text from "./preview/Text";
import Country from "./preview/Country";
import State from "./preview/State";
import style from './RenderField.scss'
import Textarea from "./preview/Textarea";
import Checkbox from "./preview/Checkbox";
import Html from './preview/Html';
import CheckboxGroup from "./preview/CheckboxGroup";
import Radio from "./preview/Radio";
import Paragraph from "./preview/Paragraph";
import Header from "./preview/Header";
import Dndholder from "./Dndholder";
import {actionIcons} from "../schema";
import Date from "./preview/Date";
import Number from "./preview/Number";
import File from "./preview/File";
import ImageGroup from "./preview/ImageGroup";
import ColorGroup from "./preview/ColorGroup";
import ToggleSwitch from "./preview/ToggleSwitch";

// const style = {
//
//     marginRight: '1.5rem',
//     marginBottom: '1.5rem',
//     color: 'white',
//     padding: '1rem',
//     textAlign: 'center',
//     fontSize: '1rem',
//     lineHeight: 'normal',
//
// }
let activeSetConfirmation = null;
const RenderField = React.forwardRef((props, ref) => {

      
    const {isOver, canDrop, connectDropTarget, connectDragSource, ItemType, history, field} = props;
    const [warning,setWarning] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const confirmationBoxRef = useRef(null);  
    const componentRef = useRef(null)

    const confirmDeletion = () => {
        props.handleRemove(props.field);
        setShowConfirmation(false);
        if (activeSetConfirmation === setShowConfirmation) {
            activeSetConfirmation = null;
        }
    };
    
    const cancelDeletion = () => {
        setShowConfirmation(false);
        if (activeSetConfirmation === setShowConfirmation) {
            activeSetConfirmation = null;
        }
    };
    
    useEffect(() => {
        function handleClickOutside(event) {
            if (showConfirmation && confirmationBoxRef.current && !confirmationBoxRef.current.contains(event.target)) {
                cancelDeletion();
            }
        }
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showConfirmation]);
    
    
    let fieldRender = null;
    switch (field.type) {
        case 'select':
            fieldRender = <Select field={field}/>
            break;
        case 'multiselect':
            fieldRender = <Select field={field}/>
            break;
        case 'text':
            fieldRender = <Text field={field}/>
            break;
        case 'numberfield':
            fieldRender = <Number field={field} type="number" />
            break;
        case 'email':
            fieldRender = <Text field={field} type="email"/>
            break;
        case 'tel':
            fieldRender = <Text field={field} type="tel"/>
            break;
        case 'url':
            fieldRender = <Text field={field} type="url"/>
            break;
        case 'textarea':
            fieldRender = <Textarea field={field}/>
            break;
        case 'htmlf':
            fieldRender = <Html field={field}/>
            break;
        case 'country':
            fieldRender = <Country field={field}/>
            break;
        case 'state':
            fieldRender = <State field={field}/>
            break;
        case 'checkbox':
            fieldRender = <Checkbox field={field}/>
            break;
        case 'checkboxGroup':
            fieldRender = <CheckboxGroup field={field}/>
            break;
        case 'toggleSwitch':
            fieldRender = <ToggleSwitch field={field}/>
            break;
        case 'radio':
            fieldRender = <Radio field={field}/>
            break;
        case 'paragraph':
            fieldRender = <Paragraph field={field}/>
            break;
        case 'header':
            fieldRender = <Header field={field}/>
            break;
        case 'dndholder':
            fieldRender = <Dndholder field={field}/>
            break;
        case 'datepicker':
            fieldRender = <Date field={field} />
            break;
        case 'timepicker':
            fieldRender = <Date field={field} />
            break;
        case 'datetimepicker':
            fieldRender = <Date field={field} />
            break;
        case 'monthpicker':
            fieldRender = <Date field={field} />
            break;
        case 'weekpicker':
            fieldRender = <Date field={field} />
            break;
        case 'file':
            fieldRender = <File field={field} />
            break;
        case 'colorpicker':
            fieldRender = <Text field={field} type="color" />
            break;
        case 'placeselector':
            fieldRender = <Text field={field} type="text"/>
            break;
        case 'imageGroup':
            fieldRender = <ImageGroup field={field}/>
            break;
        case 'colorGroup':
            fieldRender = <ColorGroup field={field}/>
            break;
        default:
            break;
    }
const isRemoveDisabled = !field.custom;
const isCopyDisabled = (['country','state'].indexOf(field.type)!==-1);

    return (
        <div
            className={style.previewOuter + ' ' + ((props.activeClass) ? style.openedField : '') + ' ' + (field.error ? style.hasError : '')}
            onClick={() => {
                return props.onClick(field.elementId);
            }}>
                {showConfirmation && (
                    <div ref={confirmationBoxRef} className={style.confirmationBox}>
                        Do you want to delete this field?
                        <button className={style.Cancel} onClick={cancelDeletion}>No</button>
                        <button className={style.Delete} onClick={confirmDeletion}>Yes</button>
                    </div>
                             
                )}
            {field.type === 'dndholder' ? null :
                <div className={style.actions}>
                    <div className={style.colCtl}>
                        <span className={style.actionClicks} onClick={(e) => {
                            return props.changeCol(-1, field, props.index)
                        }}>
                            -
                        </span>
                        <span className={style.actionText}>
                            { /* {field.col}/6 */ }
                            {(field.col)/3}/2
                        </span>
                        <span className={style.actionClicks} onClick={(e) => {
                            return props.changeCol(+1, field, props.index)
                        }}>
                            +
                        </span>
                    </div>
                    <span className={style.actionButtons+' '+(isCopyDisabled?style.disabled:'')} onClick={(e) => {
                        if(isCopyDisabled){
                            setWarning('You can\'t duplicate this field');
                            setTimeout(()=>{
                                setWarning(false);
                            },2000)
                            return;
                        }
                        return props.handleCopy(field, props.index)
                    }}>
                        <img src={actionIcons['actioncopy'].icon} title={actionIcons['actioncopy'].label}/>
                    </span>
                            <span className={style.actionButtons+' '+(isRemoveDisabled?style.disabled:'')} onClick={(e) => {
                                 if(isRemoveDisabled){
                                    setWarning('You can\'t remove default fields, Instead You can disable it');
                                   setTimeout(()=>{
                                       setWarning(false);
                                   },2000)
                                    return;
                                }
                                if (activeSetConfirmation && activeSetConfirmation !== setShowConfirmation) {
                                    activeSetConfirmation(false);
                                }
                                setShowConfirmation(true);
                                activeSetConfirmation = setShowConfirmation;
                            }}  >
                                <img src={actionIcons['actionremove'].icon} title={actionIcons['actionremove'].label}/>
                                
                            </span>
                    {warning&&<div className={style.actionWarning}>{warning}</div>}
                </div>
            }
            {fieldRender}
        </div>
    );


})


export default RenderField;
